<script>
    // ═══ Поднятие уровня — дизайн Living City. Положение настраивается в
    // редакторе худа (блок «level»). Логика прежняя: window.updateLevel()
    // зовёт геймод, дальше window.NewLvl() при смене уровня.
    import { fly } from 'svelte/transition';
    import { charLVL, charEXP } from 'store/chars'
    import { hudEditMode } from 'store/hudlayout'
    import { feedLevel } from 'store/hudfeed'
    import HudBox from './hudbox.svelte'

    let visible = false;
    let levelUp = false;      // показываем «новый уровень» крупно

    let level = -1;
    let maxExp = 0;
    let progress = 0;

    const GetMaxExp = (lvl) => {
        maxExp = 3 + lvl * 3;
    }

    const GetProgress = (exp) => {
        progress = exp * 100 / maxExp;

        if (progress > 100) progress = 100;
        else if (level != $charLVL) progress = 100;
    }

    window.updateLevel = async () => {
        onInit ();
        visible = true;
        await window.wait(500);
        GetProgress ($charEXP);
        await window.wait(5000);
        visible = false;
        if (level != $charLVL) {
            level = $charLVL;
            progress = 0;
            GetMaxExp (level);
            levelUp = true;
            await window.wait(250);
            window.NewLvl ();
            // то же событие уходит в верхнюю ленту к объявлениям: новый уровень —
            // штука важная, пусть висит дольше блока опыта (тот живёт ~4.5с)
            pushToFeed(level);
            await window.wait(4500);
            levelUp = false;
        }
    }

    // ── строка в верхней ленте ────────────────────────────────────────────
    const FEED_MS = 11000;      // держим дольше уведомления: событие редкое и важное
    let feedTimer = null;
    const pushToFeed = (lvl) => {
        feedLevel.set({ level: lvl, at: Date.now() });
        if (feedTimer) clearTimeout(feedTimer);
        feedTimer = setTimeout(() => { feedLevel.set(null); feedTimer = null; }, FEED_MS);
    };
    // в редакторе худа примерочный показ тоже кладём в ленту — видно, как встанет
    window.hudStore.demoLevelFeed = () => pushToFeed($charLVL > 0 ? $charLVL + 1 : 2);

	const onInit = () => {
        if (level === -1) {
            level = $charLVL;
            GetMaxExp (level);
            GetProgress ($charEXP);
        }
    }

    // показ для примерки в редакторе
    let demo = false;
    let demoTimer = null;
    window.hudStore.demoLevel = () => {
        onInit();
        demo = true;
        if (demoTimer) clearTimeout(demoTimer);
        demoTimer = setTimeout(() => { demo = false; demoTimer = null; }, 6000);
    };

    // вышли из редактора — примерочный показ гасим сразу, иначе окно опыта
    // остаётся висеть на экране
    $: if (!$hudEditMode && demo) {
        demo = false;
        if (demoTimer) { clearTimeout(demoTimer); demoTimer = null; }
    }

    $: show = visible || demo || $hudEditMode;
    $: pct = maxExp > 0 ? Math.max(0, Math.min(100, 100 / maxExp * $charEXP)) : 0;
</script>

{#if show}
<HudBox id="level" label="поднятие уровня">
    <div class="lcl-card" transition:fly={{ y: 20, duration: 300 }}>
        <div class="lcl-hair"></div>

        {#if levelUp}
            <div class="lcl-up">
                <span class="lcl-upkick">Новый уровень</span>
                <b class="lcl-upnum">{level}</b>
            </div>
        {/if}

        <div class="lcl-row">
            <div class="lcl-badge">{level < 0 ? 1 : level}</div>
            <div class="lcl-mid">
                <div class="lcl-caps">
                    <span class="lcl-kick">Опыт</span>
                    <span class="lcl-val">{$charEXP} / {maxExp}</span>
                </div>
                <div class="lcl-bar"><i style="width:{pct}%"></i></div>
            </div>
            <div class="lcl-next">{(level < 0 ? 1 : level) + 1}</div>
        </div>
    </div>
</HudBox>
{/if}

<style>
    .lcl-card {
        position: relative;
        width: 32vh;
        box-sizing: border-box;
        padding: 1.2vh 1.5vh 1.3vh;
        border-radius: 1.4vh;
        background: linear-gradient(135deg, rgba(18, 15, 12, 0.96), rgba(12, 10, 9, 0.93));
        border: 1px solid rgba(231, 174, 63, 0.35);
        box-shadow: 0 1.4vh 3.8vh rgba(0, 0, 0, 0.55);
        font-family: 'Manrope', 'Gilroy', sans-serif;
        overflow: hidden;
    }
    .lcl-hair { position: absolute; top: 0; left: 1.5vh; right: 1.5vh; height: 1px;
        background: linear-gradient(90deg, transparent, rgba(231, 174, 63, 0.65), transparent); }

    .lcl-up { text-align: center; margin-bottom: 1vh; }
    .lcl-upkick { display: block; font-size: 0.9vh; font-weight: 700; letter-spacing: 0.22em;
        text-transform: uppercase; color: #e7ae3f; }
    .lcl-upnum { display: block; margin-top: 0.2vh; font-size: 3.4vh; font-weight: 900; line-height: 1;
        color: #fff; text-shadow: 0 0 2.4vh rgba(231, 174, 63, 0.55); }

    .lcl-row { display: flex; align-items: center; gap: 1.1vh; }
    .lcl-badge {
        flex-shrink: 0; width: 3.6vh; height: 3.6vh; border-radius: 1vh;
        display: flex; align-items: center; justify-content: center;
        background: linear-gradient(135deg, #f0c863, #c8852f); color: #241a06;
        font-size: 1.6vh; font-weight: 900;
        box-shadow: 0 0.6vh 1.6vh rgba(224, 168, 62, 0.35);
    }
    .lcl-mid { flex: 1; min-width: 0; }
    .lcl-caps { display: flex; align-items: baseline; justify-content: space-between; margin-bottom: 0.5vh; }
    .lcl-kick { font-size: 0.9vh; font-weight: 700; letter-spacing: 0.16em; text-transform: uppercase;
        color: rgba(243, 234, 214, 0.5); }
    .lcl-val { font-size: 1.15vh; font-weight: 800; color: #fff; }
    .lcl-bar { height: 0.7vh; border-radius: 0.4vh; background: rgba(255, 255, 255, 0.12); overflow: hidden; }
    .lcl-bar i { display: block; height: 100%; border-radius: 0.4vh; transition: width .6s ease;
        background: linear-gradient(90deg, #c8852f, #f0c863); box-shadow: 0 0 1.2vh rgba(231, 174, 63, 0.5); }
    .lcl-next {
        flex-shrink: 0; width: 2.8vh; height: 2.8vh; border-radius: 0.9vh;
        display: flex; align-items: center; justify-content: center;
        background: rgba(255, 255, 255, 0.06); border: 1px solid rgba(255, 255, 255, 0.12);
        color: rgba(243, 234, 214, 0.6); font-size: 1.2vh; font-weight: 800;
    }
</style>
